import React, { ComponentProps } from 'react';
import styles from './styles.module.scss';

export const BoxBoldText = ({ children, style, className }: ComponentProps<'p'>) => (
  <p className={`${styles['bold-text']} ${className}`} style={style}>
    {children}
  </p>
);
